module.exports = __webpack_public_path__ + "static/media/slide_three.cf5b81f5.jpg";